import { appendLocaleSources } from '../../hooks/useTranslate'
import LicensePresenter from '../../api/licensePrecenter'

appendLocaleSources({
  [LicensePresenter.urn]: {
    page: {
      title: 'Загрузить лицензию',
    },
  },
}, 'ru')


